import moment from 'moment';

import { Http } from '../../../support';

const availlableTypes = ['timbrado-retenciones'];

export const initialState = {
  data: [],
  busy: false,
  selectedRows: [],
  selectedRowKeys: [],
  error: undefined,
  result: undefined,
  filters: {
    tipo: [...availlableTypes],
    to: moment().format('YYYY-MM-DD'),
    from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const setFilters = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.list.filters = {
      ...state.modulo.retenciones_masivas.files.list.filters,
      ...data,
    };
  });
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.list = {
      ...state.modulo.retenciones_masivas.files.list,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    const { filters = {}, pagination = {} } = params || {};

    state.modulo.retenciones_masivas.files.list = {
      ...state.modulo.retenciones_masivas.files.list,
      busy: true,
      filters: {
        ...state.modulo.retenciones_masivas.files.list.filters,
        ...filters,
      },
      pagination: {
        ...state.modulo.retenciones_masivas.files.list.pagination,
        ...pagination,
      },
    };
  });

  try {
    const { filters, pagination } = store.state.modulo.retenciones_masivas.files.list;

    const response = await Http.get(`/api/excel-files`, {
      params: {
        ...filters,
        ...params.filters,
        ...pagination,
        ...params.pagination,
      },
    });

    store.setState((state) => {
      state.modulo.retenciones_masivas.files.list = {
        ...state.modulo.retenciones_masivas.files.list,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.retenciones_masivas.files.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.retenciones_masivas.files.list.busy = false;
      state.modulo.retenciones_masivas.files.list.error = error.data || error;
    });
  }
};

const downloadFile = async (store, selectedRowKeys, original = undefined) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.list.busy = true;
  });

  try {
    const params = {
      as: 'link',
      original: original,
    };

    const response = await Http.get(
      `${window.BONJOUR_URL}/api/timbrado-masivo/retenciones/files/${selectedRowKeys[0]}`,
      {
        params,
      }
    );

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.retenciones_masivas.files.list.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.retenciones_masivas.files.list.busy = false;
      state.modulo.retenciones_masivas.files.list.error = error.data || error;
    });
  }
};

const downloadCfdis = async (store, selectedRowKeys) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.list.busy = true;
  });

  try {
    const params = {
      as: 'link',
    };

    const response = await Http.get(
      `${window.BONJOUR_URL}/api/timbrado-masivo/retenciones/files/${selectedRowKeys[0]}/cfdis`,
      { params }
    );

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.retenciones_masivas.files.list.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.retenciones_masivas.files.list.busy = false;
      state.modulo.retenciones_masivas.files.list.error = error.data || error;
    });
  }
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.list.data = {
      ...state.modulo.retenciones_masivas.files.list.data,
      ...data,
    };
  });
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.list = {
      ...initialState,
    };
  });
};

const RetencionesMasivasFilesListStore = {
  state: () => initialState,
  actions: {
    reset,
    change,
    paginate,
    setFilters,
    downloadFile,
    downloadCfdis,
    setSelectedRows,
  },
};

export default RetencionesMasivasFilesListStore;
